import React, { FunctionComponent } from 'react';

// MUI
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';

// Properties
import * as styles from './Header.styles';
import logoGWO from './images/logo_gwo.svg';

const Header: FunctionComponent = () => {
    return (
        <AppBar
            sx={styles.header}
            position="fixed"
        >
            <Container>
                <Grid container>
                    <Grid item xs={12}>
                        <Link href={process.env.REACT_APP_GWO_LINK}>
                            <Box
                                component="img"
                                sx={styles.logo}
                                alt="Logo"
                                src={logoGWO}
                            />
                        </Link>
                    </Grid>
                </Grid>
            </Container>
        </AppBar>
    );
};

export default Header;
